(function($){

	var showhideClearBtn = function($element)
	{
		//console.log("^^"+$element.val()+"%%");
		var $clearButton = $element.next("div.clearButton");
		if(empty($element.val()))
		{
			$element.css("padding-right", "");
			$clearButton.removeClass("visible").addClass("hidden");
		}
		else
		{
			$element.css("padding-right", $clearButton.outerWidth()+4);
			$clearButton.removeClass("hidden").addClass("visible");
		}

	}

	$.fn.addClearButton = function() {
		return this.each(function()
		{

			var $element = $(this);

			if( $.browser.msie )
			{
				// Когда qForm только разрабатывался автор событие input только-только появилось и автор про него ничего не знал
				// поэтому везде ориентировался на keyup и change. Добавим переходник )
				$element.off('input.q_keyup_legacy_hack').on('input.q_keyup_legacy_hack', function(){ if($(this).val()=="") $(this).keyup(); });
				return; // У Internet Explorer есть свой хороший крестик.
			}

			$element.after('<div class="clearButton visible">×</div>');
			var $clearBtn = $element.next();

			$clearBtn.click(function()
			{
				$element.val("").keyup().focus();
				//showhideClearBtn($element);
				//$clearBtn.hide();
			});

			$element
				.bind('keyup change paste blur', function()
				{
					//console.log("keyup");
					var that = this;
					setTimeout(function(){ showhideClearBtn($(that)); }, 100);
				});

			showhideClearBtn($element);

		});
	};

 jQuery.fn.putCursorAtEnd = function() {

  return this.each(function() {

    $(this).focus()

    // If this function exists...
    if (this.setSelectionRange) {
      // ... then use it (Doesn't work in IE)

      // Double the length because Opera is inconsistent about whether a carriage return is one character or two. Sigh.
      var len = $(this).val().length * 2;

      this.setSelectionRange(len, len);

    } else {
    // ... otherwise replace the contents with itself
    // (Doesn't work in Google Chrome)

      $(this).val($(this).val());

    }

    // Scroll to the bottom, in case we're in a tall textarea
    // (Necessary for Firefox and Google Chrome)
    this.scrollTop = 999999;

  });

};

})(jQuery);
